import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import './registerServiceWorker'

import AxiosPlugin from './axios';
Vue.use(AxiosPlugin);

import "vue-material-design-icons/styles.css"

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
